/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { TableCell } from '@mui/material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2C313D',
    color: theme.palette.common.white,
    border: 0,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    border: 0,
  },
}));

export const CustomTableCell = (props) => {
  return (
    <StyledTableCell
      key={props.index}
      scope={props.scope}
      align={props.align}
      sx={{ ...props.sx }}
    >
      {props.value}
    </StyledTableCell>
  );
};
